export type VendorTagType = 
  | 'dcm_ins' 
  | 'dcm_javascript_tag'
  | 'dcm_standard'
  | 'dcm_javascript'
  | 'sizmek_javascript'
  | 'sizmek_standard'
  | 'flashtalking'
  | 'abc';

export const tagDetection = {
  isDCMIns: (tag: string): boolean => tag.toLowerCase().includes('dcmads') || 
           tag.toLowerCase().includes('googletagservices.com/dcm/'),

  isDCMJavaScript: (tag: string): boolean => tag.toLowerCase().includes('script') && 
           (tag.toLowerCase().includes('googletag.cmd.push') ||
            tag.toLowerCase().includes('var dcm')),

  isDoubleClick: (tag: string): boolean => tag.toLowerCase().includes('doubleclick') || 
           tag.toLowerCase().includes('ddm/adj'),

  isSizmek: (tag: string): boolean => tag.toLowerCase().includes('serving-sys.com') || 
           tag.toLowerCase().includes('bs.serving-sys.com'),

  isFlashTalking: (tag: string): boolean => tag.toLowerCase().includes('flashtalking'),

  isABC: (tag: string): boolean => tag.toLowerCase().includes('api.abcsinsights.com'),

  isSizmekJavascript: (tag: string): boolean => tagDetection.isSizmek(tag) && tag.toLowerCase().includes('script'),

  isSizmekStandard: (tag: string): boolean => tagDetection.isSizmek(tag) && !tag.toLowerCase().includes('script'),

  hasMacrosAlready: (tag: string): boolean => {
    const macroIndicators = [
      '%{tURL0}',
      '%{URL0}',
      '%{etURL0}',
      '%{TIMESTAMP}',
      '%{APP_BUNDLE}'
    ];
    
    const hasGeneralMacros = macroIndicators.some(macro => tag.includes(macro));
    const hasTokenMacro = tag.includes('%{TOKEN}') || tag.includes('im_token=%{TOKEN}');
    
    return hasGeneralMacros && hasTokenMacro;
  }
};

export const getVendorName = (tagType: VendorTagType): string => {
  const vendorMap = {
    dcm_ins: 'DoubleClick INS',
    dcm_javascript_tag: 'DoubleClick JavaScript',
    dcm_standard: 'DoubleClick Standard',
    dcm_javascript: 'DoubleClick Script',
    sizmek_javascript: 'Sizmek JavaScript',
    sizmek_standard: 'Sizmek Standard',
    flashtalking: 'Flashtalking',
    abc: 'ABC Insights'
  };
  return vendorMap[tagType] || 'Unknown';
};